// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","testResultsTable":"_2551aA4G8O6z7vK_URLAh2","testResultsTableRow":"_1AkYVH4wESw5GfiVuEKWLq"};